import { RoleUpdateParameters, useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { isDuplicateRoleNameError } from '../../utils/isDuplicateRoleNameError';

export interface EditRoleMutationParams {
    role: RoleUpdateParameters;
    oldName: string;
}

export const useEditRole = () =>
    useRepositoryMutation('roles', 'update', {
        transformParams: ({ role }: EditRoleMutationParams) => ({ roles: [role] }),
        onSuccess: (_, { oldName }) => {
            showSuccessAlert({
                description: <LocalizedText textKey={TextKey.RoleEditSuccess} substitutes={{ roleName: oldName }} />,
            });
        },
        meta: {
            disableDefaultErrorHandler: isDuplicateRoleNameError,
        },
        invalidateQueries: {
            roles: ['getAll'],
        },
    });
